import { log, send } from './actions';
const logPath = 'log.sherlo';
const protocolPath = 'protocol.sherlo';
const logFn = log(logPath);
const sendFn = send(protocolPath, logFn);
const runnerBridge = {
    log: logFn,
    send: sendFn,
};
export default runnerBridge;
//# sourceMappingURL=runnerBridge.js.map